var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefcaseOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00012 8C3.44784 8 3.00012 8.44772 3.00012 9V19C3.00012 19.5523 3.44784 20 4.00012 20H20.0001C20.5524 20 21.0001 19.5523 21.0001 19V9C21.0001 8.44772 20.5524 8 20.0001 8H4.00012ZM1.00012 9C1.00012 7.34315 2.34327 6 4.00012 6H20.0001C21.657 6 23.0001 7.34315 23.0001 9V19C23.0001 20.6569 21.657 22 20.0001 22H4.00012C2.34327 22 1.00012 20.6569 1.00012 19V9Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8788 2.87856C8.44141 2.31595 9.20447 1.99988 10.0001 1.99988H14.0001C14.7958 1.99988 15.5588 2.31595 16.1214 2.87856C16.6841 3.44117 17.0001 4.20423 17.0001 4.99988V20.9999C17.0001 21.5522 16.5524 21.9999 16.0001 21.9999C15.4478 21.9999 15.0001 21.5522 15.0001 20.9999V4.99988C15.0001 4.73466 14.8948 4.48031 14.7072 4.29277C14.5197 4.10523 14.2653 3.99988 14.0001 3.99988H10.0001C9.73491 3.99988 9.48055 4.10523 9.29302 4.29277C9.10548 4.48031 9.00012 4.73466 9.00012 4.99988V20.9999C9.00012 21.5522 8.55241 21.9999 8.00012 21.9999C7.44784 21.9999 7.00012 21.5522 7.00012 20.9999V4.99988C7.00012 4.20423 7.31619 3.44117 7.8788 2.87856Z",
    fill: "#888888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseOutline);
export default __webpack_public_path__ + "static/media/briefcase-outline.4b0123be.svg";
export { ForwardRef as ReactComponent };